.ux-iws-event-calendar-item {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    color: $color-black-text;
    padding: 20px 0;
    margin-bottom: 20px;

    @media (min-width: 568px) {
        flex-flow: row nowrap;
    }

    &__date-container {
        box-sizing: border-box;
        flex: 0 0 auto;
        text-align: start;
        padding: 10px 0;
        border-bottom: 1px solid $color-gray-background;
        margin-bottom: 10px;
        width: 100%;

        @media (min-width: 568px) {
            width: calc(100% * 5 / 12);
            text-align: end;
            margin-bottom: 0;
            border-bottom: 0 none;
            padding-right: 16px;
        }
    }

    &__content-container {
        box-sizing: border-box;
        flex: 1 1 auto;
        margin-top: 10px;
        padding-bottom: 20px;

        @media (min-width: 568px) {
            width: calc(100% * 7 / 12);
            max-width: 600px;
            border-left: 1px solid $color-gray-background;
            margin-top: 0;
            padding-left: 16px;
        }
    }

    &__date,
    &__month {
        font-family: Frutiger-Bold, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
    }

    &__booth,
    &__title,
    &__location,
    &__year {
        font-family: Frutiger-Light, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
    }

    &__booth {
        color: $color-gray-text;
        font-size: 1.125rem;
        line-height: 1;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    &__title {
        font-size: 1.75rem;
        margin-bottom: 10px;
    }

    &__date,
    &__month {
        font-size: 1.75rem;
        line-height: 1.2;
    }

    &__month {
        font-size: 64px;
    }

    &__year {
        font-size: 1.125rem;
        color: $color-gray-text;
        text-transform: inherit;
        line-height: 100%;
    }

    &__location {
        font-size: 1rem;
        color: $color-gray-text;
    }

    &__links {
        margin-top: 40px;
        display: flex;
        flex-flow: row wrap;
        gap: 10px;
    }

    &__tags {
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px;
        margin-bottom: 40px;
        margin-top: 20px;
    }

    ux-tag {
        --ux-tag-background-color: #bbd03a;
        --ux-tag-background-color-hover: #bbd03a;
        --ux-tag-border-color: #bbd03a;
        --ux-tag-border-color-hover: #bbd03a;
        cursor: default;
        pointer-events: none;
        border: 0 none transparent;
        margin: 0;
    }
}
